import React from 'react';
import { Link } from "react-router-dom";
import update from 'immutability-helper';
import './JobEdit.css';

function validateQuery(str) {
  try {
      document.querySelector(str);
      return true;
  }
  catch(e) {
    console.log(e);
      // something here to check WHY it's invalid
  }
  return false;
}

function isValidUrl(urlString) {
  var urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
  '(\\#[-a-z\\d_]*)?$','i'); // validate fragment locator
  return !!urlPattern.test(urlString);
}

export class JobEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      jobName: "",
      userId: "",
      url: "",
      cron: "",
      fields: [],
      formErrors: [],
      urlError: true,
      response: {}
    };
    // Binding this keyword 
    this.addField = this.addField.bind(this);
    this.renderFieldSlot = this.renderFieldSlot.bind(this);
    this.renderChildSlot = this.renderChildSlot.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async componentDidMount() {
    if (!window.location.href.endsWith("new")) {
      const id = window.location.href.split('/').pop();
      // GET request using fetch with async/await
      const response = await fetch('/jobs/'+id);
      if (response.status === 200) {
        const data = await response.json();
        data['isEdit'] = true;
        data['formErrors'] = data.fields.map(f => { return {'selector': true}});
        data['urlError'] = true;
        this.setState(data);
      }
    }
  }

  addField() {
    this.setState((state) => {
      return {
        fields: state.fields.concat([{type:"", name: "", selector: "", children: []}]),
        formErrors: state.formErrors.concat([{children: []}])
      };
    });
  }

  addChild(i) {
    this.setState((state) => {
      return update(state, {
        fields: {[i]: {children: {$push: [{name: "", selector: ""}]}}},
        formErrors: {[i]: {children: {$push: [{selector: true}]}}},
      });
    });
  }

  handleChange(event, i, j) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if (name === 'url') {
      this.setState({
        urlError: isValidUrl(value)
      });
    } 

    //Fields
    if (j !== undefined) {
      if (name === 'selector') {
        let isValid = validateQuery(value);
        let newErrors = this.state.formErrors.slice();
        newErrors[i].children[j][name] = isValid;
        this.setState({
          formErrors: newErrors
        });
        if(!isValid) {
          return;
        }
      }
      let newFields = this.state.fields.slice();
      newFields[i].children[j][name] = value;
      this.setState({
        fields: newFields
      });
      return;
    }

    if (i !== undefined) {
      if (name === 'selector') {
        let isValid = validateQuery(value);
        let newErrors = this.state.formErrors.slice();
        newErrors[i][name] = isValid;
        this.setState({
          formErrors: newErrors
        });
        if(!isValid) {
          return;
        }
      }

      let newFields = this.state.fields.slice();
      newFields[i][name] = value;
      this.setState({
        fields: newFields
      });
    }
    else {
      this.setState({
        [name]: value
      });
    }
  }

  async handleSubmit(event, i) {
    event.preventDefault();
    const postData = {jobName: this.state.jobName, url: this.state.url, fields: this.state.fields}
    const response = await fetch('/jobs', {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    });
    const data = await response.json();
    this.setState({ response: {status: response.status, data: data}});
  }

  render() {
    const fieldList = this.state.fields.map((field, i) => {
      return (
        <div key={i}>
          {this.renderFieldSlot(i)}
        </div>
      )
    });
    const resultsLink = this.state.isEdit ? (
      <div className="alert alert-info">
        Results link: <a href={"https://scrapebuddy.lastelm.software/"+this.state.userId+"/results/"+this.state.jobName}>{"https://scrapebuddy.lastelm.software/"+this.state.userId+"/results/"+this.state.jobName}</a>
      </div>) : "";
    const responseBanner = this.state.response.status ? (
      <div class={"alert alert-" + (this.state.response.status === 200 ? "success" : "danger")} role="alert">
        Response: {JSON.stringify(this.state.response.data)}
      </div>
    ) : ""
    return (
      <div className="App">
        <div className="container">
          <div className="row">
            <div className="col-md-8 mx-auto job">
              {responseBanner}
              <form onSubmit={this.handleSubmit}>
                <div className="form-group">
                  <label htmlFor="jobName">Job Name</label>
                  <input type="text" className="form-control" name='jobName' value={this.state.jobName} onChange={this.handleChange} disabled={this.state.isEdit}/>
                </div>
                {resultsLink}
                <div className="form-group">
                  <label htmlFor="url">URL</label>
                  <input type="text" className="form-control" name='url' value={this.state.url} onChange={this.handleChange}/>
                  {this.state.urlError ? "" : (<p className="error">Not a valid url</p>)}
                </div>
                <div className="form-group">
                  <label htmlFor="cron">Cron</label>
                  <input type="text" className="form-control" name='cron' disabled={true} value="H H * * *" />
                </div>
                <button className='btn btn-info' type='button' onClick={this.addField}>Add Field</button>
                <div className='fieldList'>
                  {fieldList}
                </div>
                <div>
                  <button className='btn btn-primary mr-auto' type='submit'>Submit</button>
                  <Link className="btn btn-failure" to="/jobs" role="button">Cancel</Link>
                </div>
              </form>
            </div>
          </div>
          {JSON.stringify(this.state)}
        </div>
      </div>
    );
  }

  renderFieldSlot(i) {
    const childList = this.state.fields[i].children.map((field, j) => {
      return (
        <div key={j}>
          {this.renderChildSlot(i, j)}
        </div>
      )
    });
    const addChildBtn = this.state.fields[i]['type'] === "PARENT" ? (<button className='btn btn-info' type='button' onClick={() => this.addChild(i)}>Add Child</button>) : "";
    return (
      <div className='field-slot'>
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input type="text" className="form-control" name="name" defaultValue={this.state.fields[i]['name']} onChange={(e) => this.handleChange(e, i)} />
        </div>
        <div className="form-group">
          <label htmlFor="type">Type</label>
          <select className="form-control" name="type" value={this.state.fields[i]['type']} onChange={(e) => this.handleChange(e, i)}>
              <option value="">Select a value</option>
              <option value="SINGLE">Single</option>
              <option value="LIST">List</option>
              <option value="PARENT">Parent</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="selector">Selector</label>
          <input type="text" className="form-control" name="selector" defaultValue={this.state.fields[i]['selector']} onChange={(e) => this.handleChange(e, i)} />
          {this.state.formErrors[i]["selector"] ? "" : (<p className="error">Not a valid selector</p>)}
        </div>
        <div>
          {addChildBtn}
          {this.state.fields[i]['type'] === "PARENT" ? childList : ""}
        </div>
      </div>
    );
  }

  renderChildSlot(i, j) {
    console.log("Field: " + i + " Child: " + j);
    return (
      <div className='field-slot'>
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input type="text" className="form-control" name="name" defaultValue={this.state.fields[i].children[j]['name']} onChange={(e) => this.handleChange(e, i, j)} />
        </div>
        <div className="form-group">
          <label htmlFor="selector">Selector</label>
          <input type="text" className="form-control" name="selector" defaultValue={this.state.fields[i].children[j]['selector']} onChange={(e) => this.handleChange(e, i, j)} />
          {this.state.formErrors[i]["children"][j]["selector"] ? "" : (<p className="error">Not a valid selector</p>)}
        </div>
      </div>
    );
  }
}

export default JobEdit;
